import {combineReducers} from "redux";
import UpdateTheme from "./ThemeState";
import fileReducer from "./reducers";

export default combineReducers({
    UpdateTheme,
    fileReducer
});
